import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";
import { theme } from "~/components/Common";

const styledName = "TransactionAmount";

const styles = {
  textAlign: "end",
  margin: 0,
};

export const StyledPositiveAmount = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.info.dark,
    ...styles,
  },
});

export const StyledNegativeAmount = styled(Typography, { name: styledName })({
  "&": {
    color: theme.palette.error.main,
    ...styles,
  },
});
